export default __webpack_public_path__ + "static/media/gallery-wip-handle_00.a3f3e2b4.jpg";